import * as React from "react";
import { useState, useContext, useEffect } from "react";
import { Form, Input, Button, Modal, Checkbox } from "antd";
import { useTranslation } from "react-i18next";
import ReactHtmlParser from "react-html-parser";
import { FormattedNumber, IntlProvider } from "react-intl";
import { UserContext } from "../../../../hooks/context/userInfo";
import ModalLegal from "../../modalLegalGeneric/modalLegalGeneric";
import { convertStringToNumber } from "../../../../utils/convertStringToNumber";
import { showNotification } from "../../../../utils/notificationsGeneric";
import { numberFormat } from "../../../../utils/formatAmount";
import {
  ONLY_NUMBER_D,
  NO_CHART_REPITED,
  NO_CHART_REPITED_AND_NUMBER_DECIMAL,
} from "../../../../constants/regex";
import { useGetReward } from "src/api/api";

import "../modalReward.sass";

interface ParamProps {
  isModalRewardVisible: boolean;
  setModalRewardVisible: (value: boolean) => void;
  valueOpen: any;
  setAvailableMoney: (value: any) => void;
  isOwn: boolean;
}

// Modal reward
export default function ModalRewardProduct(params: ParamProps) {
  const [confirmRedeem, setConfirmRedeem] = useState<boolean>(false);
  const [visible, setVisible] = useState(false);
  const [checkPolicy, setCheckPolicy] = useState(false);
  const [openModalLegalB, setOpenModalLegalB] = useState(false);

  const userContext = useContext(UserContext);
  const [form] = Form.useForm();
  const { t } = useTranslation(["modalLogin", "profile", "reward"]);
  const getReward = useGetReward();


  useEffect(() => {
    setVisible(params.isModalRewardVisible);
  }, [params.isModalRewardVisible]);

  const onFinish = async () => {
    setConfirmRedeem(false);
    getReward({
      idReward: params.valueOpen?.id,
      amount: params.valueOpen.amount,
      currency: params.valueOpen?.idCurrency,
      ownReward: false,
      isProduct: true,
    })
      .then((v) => {

        showNotification(v.type.toLocaleLowerCase(), v.title, v.message, "topRight");

        if (v.type == "Success") {
          // own and success
          form.resetFields();

          params.setModalRewardVisible(false);

          setVisible(false);

          setTimeout(function () {
            window.location.reload();
          }, 2000);
        }
      })
      .catch((error) => {
        cleanForm();
      });
  };

  const cleanForm = () => {
    setCheckPolicy(false);
    setConfirmRedeem(false);
    form.resetFields();
  };

  const handleCancel = () => {
    cleanForm();
    params.setModalRewardVisible(false);
    setVisible(false);
  };

  const openModal = (e) => {
    params.setModalRewardVisible(false);
    setVisible(false);
    setOpenModalLegalB(true);
    e.stopPropagation();
  };


  return (
    <>
      <IntlProvider locale={userContext.GetLanguageUser()}>
        <Modal
          destroyOnClose
          title={t("reward:modal.title")}
          visible={visible}
          onCancel={handleCancel}
          footer={
            <div className="body-modal-reward">
              <div className="col-1 display-xs-reward"></div>
              <div className="footer-modal-reward col-md-10 col-12">
                {params.valueOpen?.messageMinMaxAmount}
              </div>
              <div className="col-1 display-xs-reward"></div>
            </div>
          }
          key="1"
          className="box-modal-reward"
        >
          <div className="body-modal-reward">
            <div className="col-1 display-xs-reward"></div>
            <div className="col-md-10 col-12">
              <div className="col-12 img-modal-reward padding-elements-form-reward">
                <img src={params.valueOpen?.img} />
              </div>
              <div className="col-12 col-sm-8 mb-3 padding-elements-form-reward-green">
                {params.valueOpen?.increment > 0 && (
                  <div className="box-max-amount-modal margin-element">
                    {ReactHtmlParser(
                      t("reward:table-result.max-amount-percentage", {
                        0: params.valueOpen?.increment,
                      })
                    )}
                  </div>
                )}
              </div>
              <div className="col-12 margin-element mt-3 mb-3 padding-elements-form-reward">
                {t("reward:modal.have")}
                <strong>
                  <FormattedNumber
                    useGrouping={true}
                    value={params.valueOpen?.amountUser}
                    style="currency"
                    currency={params.valueOpen?.idCurrency}
                  />
                </strong>
                {t("reward:modal.sentence", { 0: params.valueOpen?.name })}
              </div>
              <div className="col-12 mb-3 padding-elements-form-reward">
                <div className="margin-element">
                  <img style={{ width: '100%', height: 'auto' }} src={params.valueOpen?.image} />
                  <strong>{params.valueOpen?.title}</strong>
                </div>
              </div>
              <Form
                name="basic"
                initialValues={{ remember: true }}
                form={form}
              >


                <Form.Item className="col-12 margin-element mt-4">
                  <div style={{ display: "flex", gap: 15, alignItems: "center" }} >
                    <p style={{ margin: 0 }} >
                      <strong>
                        <FormattedNumber
                          useGrouping={true}
                          value={params.valueOpen?.amount}
                          style="currency"
                          currency={params.valueOpen?.idCurrency}
                        />
                      </strong>
                    </p>
                    <Button
                      id="btn-form-login"
                      className="col-12 primary-button"
                      type="primary"
                      size="large"
                      onClick={() => onFinish()}
                      disabled={!confirmRedeem}
                      htmlType="submit"
                      style={{flex: 1}}
                    >
                      {t("reward:table-result.button")}
                    </Button>
                  </div>

                </Form.Item>
              </Form>
              <div className="col-12 subtitle-modal-reward mb-3">

                <div style={{ marginTop: "10px" }}>
                  <Checkbox
                    checked={confirmRedeem}
                    onChange={(e) => {
                      setConfirmRedeem(e.target.checked);
                    }}
                  >
                    {t("reward:modal.confirm-redeem")}
                  </Checkbox>
                </div>
              </div>
            </div>
            <div className="col-1 display-xs-reward"></div>
          </div>
        </Modal>

        {openModalLegalB && (
          <ModalLegal
            legaBText={params.valueOpen?.legaBText}
            setVisible={setVisible}
            setOpenModalLegalB={setOpenModalLegalB}
          />
        )}
      </IntlProvider>
    </>
  );
};
